var _rect, _rect2, _g, _rect3, _rect4, _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUnlockPremium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 81,
    viewBox: "0 0 76 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34.0244,
    y: 21.4844,
    width: 38,
    height: 48,
    rx: 4,
    transform: "rotate(13.2865 34.0244 21.4844)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 17.209,
    width: 38,
    height: 48,
    rx: 4,
    fill: "#FFAB57"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29947_10589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.75 33.9586H42.375V32.5836C42.3748 31.7734 42.0832 30.9903 41.5534 30.3773C41.0236 29.7643 40.2911 29.3623 39.4895 29.2447C38.6879 29.1271 37.8707 29.3018 37.1872 29.7368C36.5037 30.1718 35.9994 30.8381 35.7665 31.6141C35.743 31.6927 35.7351 31.7752 35.7435 31.8569C35.7518 31.9385 35.7762 32.0177 35.8151 32.09C35.8541 32.1622 35.9069 32.2261 35.9705 32.2779C36.0341 32.3297 36.1074 32.3685 36.186 32.3921C36.2646 32.4156 36.3471 32.4234 36.4288 32.4151C36.5104 32.4068 36.5896 32.3824 36.6619 32.3435C36.7341 32.3045 36.798 32.2517 36.8498 32.1881C36.9017 32.1244 36.9405 32.0512 36.964 31.9726C37.1108 31.4841 37.4284 31.0648 37.8588 30.791C38.2892 30.5173 38.8037 30.4075 39.3083 30.4816C39.8129 30.5557 40.2741 30.8088 40.6076 31.1947C40.9411 31.5806 41.1248 32.0735 41.125 32.5836V33.7086C41.125 33.7749 41.0987 33.8385 41.0518 33.8854C41.0049 33.9322 40.9413 33.9586 40.875 33.9586H35.25C34.9848 33.9586 34.7304 34.0639 34.5429 34.2515C34.3554 34.439 34.25 34.6934 34.25 34.9586V40.2086C34.25 40.4738 34.3554 40.7281 34.5429 40.9157C34.7304 41.1032 34.9848 41.2086 35.25 41.2086H42.75C43.0152 41.2086 43.2696 41.1032 43.4571 40.9157C43.6446 40.7281 43.75 40.4738 43.75 40.2086V34.9586C43.75 34.6934 43.6446 34.439 43.4571 34.2515C43.2696 34.0639 43.0152 33.9586 42.75 33.9586ZM39 38.4586C38.8022 38.4586 38.6089 38.3999 38.4444 38.29C38.28 38.1802 38.1518 38.024 38.0761 37.8413C38.0004 37.6585 37.9806 37.4575 38.0192 37.2635C38.0578 37.0695 38.153 36.8913 38.2929 36.7515C38.4327 36.6116 38.6109 36.5164 38.8049 36.4778C38.9989 36.4392 39.2 36.459 39.3827 36.5347C39.5654 36.6104 39.7216 36.7386 39.8315 36.903C39.9414 37.0675 40 37.2608 40 37.4586C40 37.7238 39.8946 37.9781 39.7071 38.1657C39.5196 38.3532 39.2652 38.4586 39 38.4586Z",
    fill: "white"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 52.209,
    width: 30,
    height: 8,
    rx: 4,
    fill: "#2F2F2F"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 55.209,
    width: 22,
    height: 2,
    rx: 1,
    fill: "#606060"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.9897 1.15523C62.7914 2.40449 62.2841 3.58534 61.5142 4.59038C61.2979 4.87286 61.2429 5.24619 61.3753 5.57631C61.5077 5.90624 61.8057 6.13877 62.1575 6.19438C63.4099 6.39218 64.5936 6.89822 65.6011 7.66625C65.8843 7.88209 66.2585 7.93693 66.5895 7.80485C66.9202 7.67274 67.1533 7.37545 67.2091 7.02431C67.4074 5.77506 67.9146 4.59441 68.6845 3.58937C68.9009 3.30689 68.9559 2.93356 68.8235 2.60343C68.6911 2.2735 68.393 2.04097 68.0412 1.98537C66.7889 1.78757 65.6054 1.28155 64.5979 0.513527C64.3147 0.297682 63.9404 0.24284 63.6095 0.374919C63.2786 0.506801 63.0455 0.804098 62.9897 1.15523Z",
    fill: "#FFAB57"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.01784 45.4838C4.91641 46.1229 4.65691 46.7269 4.26306 47.2411C4.15237 47.3856 4.12425 47.5765 4.19198 47.7454C4.25973 47.9142 4.41218 48.0331 4.59214 48.0616C5.23276 48.1628 5.83831 48.4216 6.3537 48.8145C6.49856 48.9249 6.69 48.953 6.85929 48.8854C7.02848 48.8179 7.14772 48.6658 7.17625 48.4861C7.27768 47.8471 7.53717 47.2431 7.93102 46.729C8.0417 46.5845 8.06983 46.3935 8.0021 46.2246C7.93435 46.0559 7.78189 45.9369 7.60193 45.9085C6.96131 45.8073 6.35587 45.5484 5.84048 45.1555C5.69562 45.0451 5.50418 45.0171 5.33489 45.0846C5.16561 45.1521 5.04637 45.3042 5.01784 45.4838Z",
    fill: "#2F2F2F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29947_10589"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(33 29.209)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlockPremium);
export default __webpack_public_path__ + "static/media/unlock-premium.f9f3265628978e53b7993da5475cd1f4.svg";
export { ForwardRef as ReactComponent };